import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    "@keyframes blink": {
        "0%": { opacity: 0.2 },
        "20%": { opacity: 1 },
        "100%": { opacity: 0.2 },
    },
    dotContainer: {
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: "4px 2px",
    },
    dot: {
        animationName: "$blink",
        animationDuration: "1.4s",
        animationIterationCount: "infinite",
        animationFillMode: "both",
        fontSize: 14,
        fontWeight: "bold",
        lineHeight: "10px",
        display: "inline-block",
    },
    dot1: { animationDelay: "0s" },
    dot2: { animationDelay: "0.2s" },
    dot3: { animationDelay: "0.4s" },
});

const DotsLoading = () => {
    const classes = useStyles();

    return (
        <div className={classes.dotContainer}>
            <span
                className={`${classes.dot} ${classes.dot1}`}
                style={{ color: "inherit" }}
            >
                .
            </span>
            <span
                className={`${classes.dot} ${classes.dot2}`}
                style={{ color: "inherit" }}
            >
                .
            </span>
            <span
                className={`${classes.dot} ${classes.dot3}`}
                style={{ color: "inherit" }}
            >
                .
            </span>
        </div>
    );
};

export default DotsLoading;